@if (_visible) {
  <div
    @overlayFadeAnimation
    (@overlayFadeAnimation.done)="onOverlayAnimationDone($event)"
    class="dialog-overlay"
    [style.z-index]="overlayZIndex"
    [attr.data-type]="effectiveType()"
    (pointerdown)="onOverlayPointerDown($event)"
    (pointerup)="handleBackdropClick($event)"
    tabindex="-1"
    role="button"
  >
    <div
      [@dialogEnterLeave]="dialogAnimationParams"
      class="dialog-container"
      [attr.data-size]="size"
      [attr.data-type]="effectiveType()"
      [attr.data-show-footer]="showFooter"
      (pointerdown)="onContentPointerDown($event)"
      tabindex="0"
      role="dialog"
      aria-modal="true"
    >
      <!-- Drag handle (BottomSheet only) -->
      @if (effectiveType() === 'BottomSheet' && showHandle) {
        <div class="dialog-handle-bar">
          <div class="dialog-handle"></div>
        </div>
      }

      <!-- Close Button -->
      @if (closable && !showHeader) {
        <button
          class="dialog-close-button"
          type="button"
          aria-label="Close dialog"
          (click)="handleClose()"
        >
          <umss-icon name="phosphorX" size="20px" />
        </button>
      }

      <!-- Content -->
      <div class="dialog-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
